<!-- src/lib/components/migration/ImportResults.svelte -->
<!-- Step 7: Final summary after import completes or fails -->
<script lang="ts">
  interface Props {
    status: 'done' | 'error';
    errorMsg?: string;
    onClose: () => void;
  }
  let { status, errorMsg, onClose }: Props = $props();
</script>

<div class="step">
  <div class="result-icon" class:success={status === 'done'} class:failure={status === 'error'}>
    {#if status === 'done'}
      <span aria-hidden="true">✓</span>
    {:else}
      <span aria-hidden="true">✕</span>
    {/if}
  </div>

  {#if status === 'done'}
    <h2 class="step-title">Import complete!</h2>
    <p class="step-hint">Your data has been imported into agentboard. You can now close this wizard and explore your project.</p>
  {:else}
    <h2 class="step-title">Import failed</h2>
    <p class="step-hint">Something went wrong during the import.</p>
    {#if errorMsg}
      <p class="error-detail">{errorMsg}</p>
    {/if}
    <p class="step-hint">You can try again or contact support if the issue persists.</p>
  {/if}

  <div class="actions">
    <button class="btn-primary" onclick={onClose}>Close</button>
  </div>
</div>

<style>
.step { display: flex; flex-direction: column; align-items: center; gap: 1rem; text-align: center; padding: 1rem 0; }
.step-title { margin: 0; font-size: 1.1rem; font-weight: 600; color: var(--text-primary); }
.step-hint { margin: 0; font-size: 0.82rem; color: var(--text-muted); max-width: 360px; }

.result-icon {
  width: 56px; height: 56px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.6rem; font-weight: 700;
}
.result-icon.success {
  background: oklch(0.72 0.28 310 / 0.12);
  color: var(--ab-purple-bright);
  border: 2px solid oklch(0.72 0.28 310 / 0.32);
}
.result-icon.failure {
  background: oklch(0.62 0.26 25 / 0.12);
  color: var(--ab-red-bright);
  border: 2px solid oklch(0.62 0.26 25 / 0.32);
}

.error-detail {
  margin: 0;
  font-size: 0.78rem;
  color: var(--ab-red-bright);
  font-family: 'JetBrains Mono', monospace;
  background: rgba(255,255,255,0.02);
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.06);
  max-width: 400px;
  word-break: break-word;
}

.actions { display: flex; justify-content: center; margin-top: 0.5rem; }

.btn-primary {
  background: oklch(0.72 0.28 310 / 0.12);
  border: 1px solid oklch(0.72 0.28 310 / 0.32);
  color: var(--ab-purple-bright);
  padding: 0.5rem 2rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background 120ms ease;
}
.btn-primary:hover { background: oklch(0.72 0.28 310 / 0.22); }
</style>
